/**
 * Enum for batch processing types
 * Used by both client and server code to ensure consistency
 */
export enum EnumBatchType {
  /**
   * For preparing reserved lists (standard lists)
   */
  PREPARE_USER_LIST = 0,
  PREPARE_RESERVED_LIST = 1,

  HYDRATE_NEWS_SOURCES = 2,
  HYDRATE_NEWS_CONTENT = 3,
  HYDRATE_BATCH_FROM_DAILY_NEWS = 4,
  HYDRATE_BATCH_WITH_CURRENT_QUOTE = 5,
  HYDRATE_BATCH_WITH_MARKET_UPDATE = 6,
  HYDRATE_SYMBOLS_WITH_SENTIMENT = 7,
  REFRESH_TAGGED_NEWS = 8,
  HYDRATE_USER_BULLETIN_CONTENT = 9,
  HYDRATE_BATCH_CONTENT = 10,
  MARKET_SUMMARY = 11,
  REFRESH_SEC_FILINGS = 12,
  HYDRATE_AUDIO_BRIEFINGS = 13,
  HYDRATE_USER_AUDIO_CLIPS = 14,
  UPDATE_USER_STREAK = 15,
  ASSIGN_BATCH_TO_USERS = 16,
}

/**
 * Helper function to get a human-readable batch name based on batch type
 * The step number is automatically derived from the enum value
 * @param batchType The batch type enum value
 * @returns string A descriptive name for the batch
 */
export function getBatchNameForType(batchType: EnumBatchType): string {
  switch (batchType) {
    case EnumBatchType.PREPARE_USER_LIST:
      return `Prepare User List`;
    case EnumBatchType.PREPARE_RESERVED_LIST:
      return `Prepare Reserved List`;
    case EnumBatchType.HYDRATE_NEWS_SOURCES:
      return `Hydrate News Sources`;
    case EnumBatchType.HYDRATE_NEWS_CONTENT:
      return `Hydrate News Content`;
    case EnumBatchType.HYDRATE_BATCH_FROM_DAILY_NEWS:
      return `Hydrate Batch from News`;
    case EnumBatchType.HYDRATE_BATCH_WITH_CURRENT_QUOTE:
      return `Hydrate Batch Current Quotes`;
    case EnumBatchType.HYDRATE_BATCH_WITH_MARKET_UPDATE:
      return `Hydrate Batch Market Update`;
    case EnumBatchType.HYDRATE_SYMBOLS_WITH_SENTIMENT:
      return `Hydrate Symbols Sentiment`;
    case EnumBatchType.REFRESH_TAGGED_NEWS:
      return `Refresh Tagged News`;
    case EnumBatchType.HYDRATE_USER_BULLETIN_CONTENT:
      return `Hydrate User Bulletin Content`;
    case EnumBatchType.MARKET_SUMMARY:
      return `Market Summary`;
    case EnumBatchType.HYDRATE_BATCH_CONTENT:
      return `Hydrate Batch Content`;
    case EnumBatchType.HYDRATE_AUDIO_BRIEFINGS:
      return `Hydrate Audio Briefings`;
    case EnumBatchType.UPDATE_USER_STREAK:
      return `Update User Streak`;
    case EnumBatchType.ASSIGN_BATCH_TO_USERS:
      return `Assign Batch To Users`;
    case EnumBatchType.REFRESH_SEC_FILINGS:
      return `Refresh SEC Filings`;
    case EnumBatchType.HYDRATE_USER_AUDIO_CLIPS:
      return `Hydrate User Audio Clips`;
    default:
      return `Batch Type ${batchType}`;
  }
}

